import { capitalize, isNil } from 'lodash-es'

import type {
  EmployerAccountPermission,
  EmployerAccountSummary,
  LocationsSummary,
} from './EmployerAccountsList.types'

// Company-wide permissions have no location. An account with no permissions at all
// comes back as a single location-less row with no codes, which isn't company-wide.
const isCompanyWide = (permission: EmployerAccountPermission) =>
  isNil(permission.work_location_id) && permission.codes.length > 0

export const locationsSummary = ({ level, permissions = [] }: EmployerAccountSummary): LocationsSummary => {
  if (level === 'main') return { label: 'All (main account)', companyWide: false }
  if (level === 'disabled') return { label: '–', companyWide: false }

  const locationCount = new Set(
    permissions.filter(p => !isNil(p.work_location_id)).map(p => p.work_location_id),
  ).size
  const companyWide = permissions.some(isCompanyWide)

  if (locationCount === 0) {
    return { label: companyWide ? 'Company-wide only' : 'No locations', companyWide: false }
  }

  return {
    label: `${locationCount.toLocaleString('en-GB')} location${locationCount === 1 ? '' : 's'}`,
    companyWide,
  }
}

export const accessAtVenue = ({ permissions = [] }: EmployerAccountSummary, venueID: string | number) => {
  const venuePermission = permissions.find(p => String(p.work_location_id) === String(venueID))

  return venuePermission
    ? venuePermission.codes.map(code => capitalize(code.replace(/_/g, ' '))).join(', ')
    : ''
}
